module.exports = __webpack_public_path__ + "img/miguelMoleiro.46519983.webp";